import React from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Document, Page, pdfjs } from "react-pdf";
import { DownloadOutlined, LeftOutlined } from "@ant-design/icons";
import CustomScrollbars from '../../utils/CustomScrollbars'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


function PdfPreview({ numPages, setIsPdf, onDocumentLoadSuccess, pdfUrl }) {
   return (
      <div className="pdfContent gx-mb-3" >
         <div className="gx-module-box-topbar gx-p-0" style={{ position: "relative", justifyContent: 'space-between' }}>
            {/* <i
					className="icon icon-arrow-left gx-icon-btn pdfBack"
					onClick={() => {
						setIsPdf(false);
					}}
				/> */}
            <span className='pdfBack'>
               <LeftOutlined onClick={() => setIsPdf(false)} />Back
            </span>
            <span className="downloadPdf">
               <a target="_blank" href={pdfUrl}>
                  <DownloadOutlined />
               </a>
            </span>
         </div>
         <div>
            <div className="pdfCover">
               <CustomScrollbars className="gx-wall-scroll">
                  <TransformWrapper defaultPositionX={0}>
                     <TransformComponent>
                        <Document
                           file={pdfUrl}
                           onLoadSuccess={onDocumentLoadSuccess}
                        >
                           {Array.from(new Array(numPages), (el, index) => (
                              <Page
                                 key={`page_${1 + 1}`}
                                 pageNumber={index + 1}
                                 renderTextLayer={false}
                                 className="pdfPages"
                                 scale={1}
                              />
                           ))}
                        </Document>
                     </TransformComponent>
                  </TransformWrapper>
               </CustomScrollbars>
            </div>
         </div>
      </div>
   );
}

export default PdfPreview;
